/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */
import * as React from "react"
import UniversalLink from "§/src/utils/UniversalLink"
import { sitesUrls } from "§/src/utils/sitesUrls"

// Assets
import Circle from '§/src/images/svg/circle.svg';
import CircleChecked from '§/src/images/svg/circle-checked.svg';

// Styles
import './_lang-menu.scss';


const LangMenu = ( props ) => {

  const langMenu = props.wpMenu.nodes;
  const language = props?.lang?.locale?.locale || 'it_IT';
  const className = props.className;
  const buttonClass = props.buttonClass;
  const theme = props.theme;
  const id = props.id;
  const translations = props?.lang?.translations;
  const langReplace = props?.langReplace || null;

  // Fix /en/home/ base url
  const filteredHref = translations?.[0]?.href === "/en/home/" ? "/en/" : translations?.[0]?.href;


  return (

    <div id={id} className={'language-menu ' + className}>
      <button className={'btn btn-sm dropdown-toggle ' + buttonClass} type="button" data-bs-toggle="dropdown" aria-expanded="false">
        {langMenu.map((menuItem, index) => {
          if(menuItem.cssClasses.includes(language)){
            return(
              menuItem.title
            )
          }
        })}
      </button>
      <ul className={'dropdown-menu py-4 ' + theme}>
        {langMenu.map((menuItem, index) => {

          const menuClasses = menuItem.cssClasses
          const liClass = menuClasses.includes(language) ? 'active' : ''
          const Checked = menuClasses.includes(language) ? CircleChecked : Circle

          // get references
          if(menuClasses.includes('de_DE')){
            var siteInfo = sitesUrls('de_DE', translations, langReplace)
          } else if(menuClasses.includes('es_ES')){
            var siteInfo = sitesUrls('es_ES', translations, langReplace)
          } else if(menuClasses.includes('fr_FR')){
            var siteInfo = sitesUrls('fr_FR', translations, langReplace)
          } else if(menuClasses.includes('it_IT')){
            var siteInfo = sitesUrls('it_IT', translations, langReplace)
          } else if(menuClasses.includes('pt_PT')){
            var siteInfo = sitesUrls('pt_PT', translations, langReplace)
          } else if(menuClasses.includes('zh_CN')){
            var siteInfo = sitesUrls('zh_CN', translations, langReplace)
          } else {
            var siteInfo = sitesUrls('en_US', translations, langReplace)
          }

          var tSiteUrl = siteInfo.url
          var productSlug = siteInfo.productSlug
          var tSiteId = siteInfo.siteId
          var tUrl = siteInfo.tUrl

          return(
            <li
            className={liClass}
            key={index}
            >
              <UniversalLink
                className="dropdown-item"
                to={ menuClasses.includes(language) ? '' : filteredHref }
                activeClassName="active"
              >
                <span>{menuItem.title}</span>
              </UniversalLink>
            </li>
          )
        })}
      </ul>
    </div>

  )
}

export default LangMenu
